<template>
  <div class="overview">
    <love-map :school="schoolList" />
    
    <slot name="logo"></slot>
    <slot name="infor"></slot>

    <div class="data">
      <div class="main">
        <div class="school">
          <h5>累计捐赠学校</h5>
          <span class="count">{{ formatNumber(schoolList.length) }}</span>
          <span class="unit">所</span>
        </div>
        <div class="separator"></div>
        <div class="course">
          <h5>累计捐赠课程</h5>
          <span class="count">{{ formatNumber(duration2course(totalDuration)) }}</span>
          <span class="unit">节</span>
        </div>
      </div>
      <p v-show="totalDuration > 0" class="tip">相当于</p>
      <div class="value">{{ formatText(duration2course(totalDuration)) }}</div>
    </div>

    <news class="news" v-show="schoolList.length > 0" :shared="shared" :donationObjects="donationObjects" />

    <transition name="fade-in-up" appear>
      <slot name="button">
        <touch tag="button" class="share" type="button" @tap="share">邀请好友一起捐</touch>
      </slot>
    </transition>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import actions from '@/store/action-types'

  import LoveMap from '@/components/LoveMap'
  import News from '@/components/News'

  export default {
    name: 'overview',
    props: {
      shared: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        schoolList: 'donationObjects'
      }),
      ...mapState({
        basicDonateDuration: state => state.BASIC_DONATE_DURATION,
        nick: state => state.overview.nick,
        avatar: state => state.overview.avatar,
        shareId: state => state.share.shareId,
        joinRanking: state => state.overview.joinRanking,
        totalDuration: state => state.overview.totalDuration,
        donationObjects: state => state.overview.donationObjects
      })
    },
    activated () {
      if (!this.shared) {
        this.getSummary()
        this.$track.sendPageTrack('csr_map')
      }
    },
    methods: {
      formatNumber (number) {
        return number < 10 ? `0${number}` : number
      },
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      },
      formatText (course) {
        if (Math.floor(course / 32) > 0) {
          return `捐赠了 ${Math.floor(course / 32)} 个学期的英语课程`
        } else if (Math.floor(course / 8) > 0) {
          return `捐赠了 ${Math.floor(course / 8)} 月的英语课程`
        } else if (Math.floor(course / 2) > 0) {
          return `捐赠了 ${Math.floor(course / 2)} 周的英语课程`
        } else if (course > 0) {
          return `捐赠了 ${course} 节英语课程`
        } else {
          return `还没有捐赠哦，先去学习吧~`
        }
      },
      getSummary () {
        this.$store.dispatch(actions.fetch.USER_SUMMRAY).then(() => {
          this.updateUserInfor()
        })
      },
      updateUserInfor () {
        this.$store.dispatch(actions.post.SHARED_CONTENTS, {
          targetType: 'custom',
          extra: {
            nick: this.nick,
            avatar: this.avatar,
            joinRanking: this.joinRanking,
            schoolList: this.schoolList,
            totalDuration: this.totalDuration,
            donationObjects: this.donationObjects
          }
        })
      },
      share () {
        this.$track.sendActionTrack('csr_map', 'click_invite_button')
        this.wxShareRegister()
      },
      _shareDesc () {
        if (this.joinRanking > 0) {
          return this.totalDuration >= this.basicDonateDuration
            ? `我是第${this.joinRanking}个参与流利说「你学英语我捐课」的人，我已捐课${this.duration2course(this.totalDuration)}节，助力教育公益就差你喽！`
            : `我是第${this.joinRanking}个参与流利说「你学英语我捐课」的人，助力教育公益就差你喽！`
        } else {
          return this.totalDuration >= this.basicDonateDuration
            ? `我在流利说「你学英语我捐课」活动中捐了${this.duration2course(this.totalDuration)}节课，就差你啦！`
            : '我在参加流利说「你学英语我捐课」活动，助力教育公益就差你喽！'
        }
      },
      wxShareRegister () {
        this.$wxShare.share({
          title: this._shareDesc(),
          desc: this._shareDesc(),
          link: `${location.origin + location.pathname}invite.html?shareId=${this.shareId}`,
          imgUrl: 'https://cdn.llscdn.com/fe-static/lls-with-tfchina/share-OPxietMp.jpg'
        })
      }
    },
    components: {
      LoveMap,
      News
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .overview {
    padding-bottom: 60px;
    overflow: hidden;
    box-sizing: border-box;
    .data {
      padding: 40px 60px;
      box-sizing: border-box;
      .main {
        display: flex;
      }
      .school,
      .course {
        h5 {
          margin-bottom: 40px;
          font-size: 28px;
          font-weight: normal;
          color: rgba($black, 0.54);
          line-height: 28px;
        }
        .count {
          margin-right: 40px;
          font-size: 100px;
          font-weight: bold;
          color: $black;
          line-height: 120px;
        }
        .unit {
          position: relative;
          top: -14px;
          display: inline-block;
          width: 80px;
          height: 46px;
          font-size: 28px;
          font-weight: 400;
          line-height: 46px;
          text-align: center;
          background-color: $grey;
          border-radius: 23px;
        }
      }
      .separator {
        position: relative;
        top: 100px;
        display: block;
        width: 3px;
        height: 50px;
        margin-left: 60px;
        margin-right: 60px;
        background-color: $grey;
      }
      .tip {
        margin-top: 40px;
        font-size: 28px;
        color: rgba($black, 0.54);
        line-height: 42px;
      }
      .value {
        @include border-radius;
        margin-top: 30px;
        margin-bottom: 40px;
        width: 100%;
        height: 120px;
        font-size: 36px;
        font-weight: 400;
        color: $black;
        text-align: center;
        line-height: 120px;
        background-color: $grey;
      }
    }
    .news {
      border-top: 2px solid $grey;
    }
    .share {
      @include reset-button;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 20;
      width: 100%;
      height: 98px;
      font-size: 36px;
      color: $white;
      text-align: center;
      line-height: 98px;
      background-color: $darkRed;
    }
  }
  .fade-in-up-enter-active {
    transition: all 0.5s 0.5s ease-in;
  }
  .fade-in-up-enter {
    transform: translate3d(0, 100%, 0);
  }
</style>



// WEBPACK FOOTER //
// Overview.vue?5fa5065c